export default __webpack_public_path__ + "static/media/worker_panel_bg.b17797ec.svg";